import ChallengePoint from "../Model/ChallengePoint";
export class ChallengeFactory {
    constructor(distanceCalculator) {
        this.distanceCalculator = distanceCalculator;
    }
    createChallenge(route, questions, numPoints, questionsByPoint) {
        //Seleccionamos todas las preguntas que son aplicables a esta ruta
        const filteredQuestions = this.filterQuestions(route, questions);
        //Ordenamos el array de preguntas filtrado de manera aleatoria
        filteredQuestions.sort(() => -0.5 + Math.random());
        //Creamos el array de puntos de desafío
        const pathInfo = this.getPathInfo(route);
        const points = [];
        while (points.length < numPoints && filteredQuestions.length) {
            //Dividimos la ruta entre tantos segmentos como puntos
            //de desafío se hayan solicitado. Calculamos la distancia a la que
            //está el primer vertice de ruta perteneciente al siguiente segmento.
            const segmentEndDist = (pathInfo.dist / numPoints) * (points.length + 1);
            //Seleccionamos todos los vertices de ruta con una
            //distancia menor a la distancia de fin del segmento actual
            let vertIndex = pathInfo.path.findIndex(({ dist }) => dist > segmentEndDist);
            if (vertIndex === -1) {
                vertIndex = pathInfo.path.length;
            }
            const segmentVerts = pathInfo.path.splice(0, vertIndex);
            //Seleccionamos un vertice del segmento de manera aleatoria
            const pointVert = segmentVerts[Math.floor(segmentVerts.length * Math.random())];
            //Creamos el punto
            const point = new ChallengePoint({
                id: this.createChallengePointId(),
                coords: { lon: pointVert.vert[0], lat: pointVert.vert[1] },
                questions: filteredQuestions.splice(0, questionsByPoint),
                isCompleted: false
            });
            points.push(point);
        }
        return points;
    }
    /**
     * Retorna un array de preguntas aplicables a la ruta seleccionada.
     * @param {Route} route
     * @param {Question[]} questions
     * @returns {Question[]} array de preguntas
     */
    filterQuestions(route, questions) {
        return questions.filter(question => {
            var _a;
            return !((_a = question.constraints) === null || _a === void 0 ? void 0 : _a.routes) || question.constraints.routes.includes(route.id);
        });
    }
    getPathInfo(route) {
        const pathInfo = {
            dist: 0,
            path: [{
                    dist: 0,
                    vert: route.path[0]
                }]
        };
        for (let i = 1; i < route.path.length; i++) {
            const [plon, plat] = route.path[i - 1];
            const [clon, clat] = route.path[i];
            const dist = this.distanceCalculator.calcDistance({ lon: plon, lat: plat }, { lon: clon, lat: clat });
            pathInfo.dist += dist;
            const pathVert = {
                dist: pathInfo.dist,
                vert: route.path[i]
            };
            pathInfo.path.push(pathVert);
        }
        return pathInfo;
    }
    createChallengePointId() {
        const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let id = '';
        while (id.length < 10) {
            id += chars[Math.floor(chars.length * Math.random())];
        }
        return id;
    }
}
